import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteMeetingNote() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { clientId: string; meetingNoteId: string }>({
    mutationFn: ({ clientId, meetingNoteId }: { clientId: string; meetingNoteId: string }) =>
      api.delete(`clients/${clientId}/meeting-notes/${meetingNoteId}`),
    onSuccess: (_data, { clientId }) => {
      queryClient.invalidateQueries({ queryKey: ['clients', clientId, 'meeting-notes'] });
    },
  });

  const deleteMeetingNote = async (clientId: string, meetingNoteId: string) => {
    return mutateAsync({ clientId, meetingNoteId });
  };

  return {
    deleteMeetingNote,
    error,
    isLoading,
    reset,
  };
}
